import reframe from 'nike-re-framejs';

reframe.regSub('markdown.article', (db, [_, articleCode]) => db.getIn(['cms', 'markdown', articleCode]));

reframe.regSub('markdown.article.title', (db, [_, articleCode]) => db.getIn(['cms', 'markdown', articleCode, 'title']));

reframe.regSub('cms.section.menu', (db, [_, section]) => db.getIn(['cms', 'sections', section, 'menu']));

reframe.regSub('cms.section.article', (db, [_, section, url]) =>
    db.getIn(['cms', 'sections', section, 'articles', url])
);
